module.exports = __webpack_public_path__ + "img/currency2.10d50e36.png";